import CryptoJS from 'crypto-js';
import {SECRET_KEY} from './constants';
// Cambia esto a una clave segura
const IV = CryptoJS.lib.WordArray.random(16); // Genera un vector de inicialización aleatorio

// Función para encriptar datos
export const encryptData = (data) => {
  if (!data) {
    return;
  }
  const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY, {iv: IV});
  return encrypted.toString();
};

// Función para desencriptar datos
export const decryptData = (encryptedData) => {
  if (!encryptedData) {
    return;
  }
  const decrypted = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY, {iv: IV});
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const resetDataconfig = (_json) =>{
  const configUserData = JSON.parse(decryptData(localStorage.getItem('_config')));
  configUserData.unidadId = _json.unidadId;
  configUserData.nivelRootId = _json.nivelRootId;
  localStorage.setItem('_config', encryptData(JSON.stringify(configUserData)));
};

export const deleteDataSuplantar = () =>{
  sessionStorage.removeItem('_impersonate');
  const configUserData = JSON.parse(decryptData(localStorage.getItem('_config')));
  configUserData.impersonateUser = null;
  configUserData.impersonateUserName = '';
  localStorage.setItem('_config', encryptData(JSON.stringify(configUserData)));
  window.location.href = '/';
};
